export default __webpack_public_path__ + "static/media/tShirt2.1e772462.jpg";